var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('click')}}},[_c('closeIcon',{staticClass:"close__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }